/**
 * Generated by the protoc-gen-ts.  DO NOT EDIT!
 * compiler version: 7.34.1
 * source: checkout/checkout.proto
 * git: https://github.com/thesayyn/protoc-gen-ts */
import * as dependency_1 from "./../payments/payments";
import * as dependency_2 from "./../google/protobuf/timestamp";
import * as pb_1 from "google-protobuf";
export namespace checkout.v1 {
    export enum CheckoutStatus {
        CHECKOUT_STATUS_UNSPECIFIED = 0,
        CHECKOUT_STATUS_PENDING = 1,
        CHECKOUT_STATUS_CANCELED = 2,
        CHECKOUT_STATUS_COMPLETED = 3,
        CHECKOUT_STATUS_EXPIRED = 4,
        CHECKOUT_STATUS_FAILED = 5
    }
    export class LineItem extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            itemId?: string;
            priceId?: string;
            quantity?: number;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("itemId" in data && data.itemId != undefined) {
                    this.itemId = data.itemId;
                }
                if ("priceId" in data && data.priceId != undefined) {
                    this.priceId = data.priceId;
                }
                if ("quantity" in data && data.quantity != undefined) {
                    this.quantity = data.quantity;
                }
            }
        }
        get itemId() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set itemId(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get priceId() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set priceId(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get quantity() {
            return pb_1.Message.getFieldWithDefault(this, 3, 0) as number;
        }
        set quantity(value: number) {
            pb_1.Message.setField(this, 3, value);
        }
        static fromObject(data: {
            itemId?: string;
            priceId?: string;
            quantity?: number;
        }): LineItem {
            const message = new LineItem({});
            if (data.itemId != null) {
                message.itemId = data.itemId;
            }
            if (data.priceId != null) {
                message.priceId = data.priceId;
            }
            if (data.quantity != null) {
                message.quantity = data.quantity;
            }
            return message;
        }
        toObject() {
            const data: {
                itemId?: string;
                priceId?: string;
                quantity?: number;
            } = {};
            if (this.itemId != null) {
                data.itemId = this.itemId;
            }
            if (this.priceId != null) {
                data.priceId = this.priceId;
            }
            if (this.quantity != null) {
                data.quantity = this.quantity;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.itemId.length)
                writer.writeString(1, this.itemId);
            if (this.priceId.length)
                writer.writeString(2, this.priceId);
            if (this.quantity != 0)
                writer.writeInt32(3, this.quantity);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): LineItem {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new LineItem();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.itemId = reader.readString();
                        break;
                    case 2:
                        message.priceId = reader.readString();
                        break;
                    case 3:
                        message.quantity = reader.readInt32();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): LineItem {
            return LineItem.deserialize(bytes);
        }
    }
    export class CheckoutSession extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            id?: string;
            items?: LineItem[];
            currency?: string;
            totalAmount?: number;
            successUrl?: string;
            cancelUrl?: string;
            status?: CheckoutStatus;
            paymentType?: dependency_1.payments.v1.PaymentType;
            metadata?: Map<string, string>;
            customer?: CustomerInfo;
            userId?: string;
            tenantId?: string;
            orderId?: string;
            coupon?: string;
            offer?: AppliedOffer;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [2], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("id" in data && data.id != undefined) {
                    this.id = data.id;
                }
                if ("items" in data && data.items != undefined) {
                    this.items = data.items;
                }
                if ("currency" in data && data.currency != undefined) {
                    this.currency = data.currency;
                }
                if ("totalAmount" in data && data.totalAmount != undefined) {
                    this.totalAmount = data.totalAmount;
                }
                if ("successUrl" in data && data.successUrl != undefined) {
                    this.successUrl = data.successUrl;
                }
                if ("cancelUrl" in data && data.cancelUrl != undefined) {
                    this.cancelUrl = data.cancelUrl;
                }
                if ("status" in data && data.status != undefined) {
                    this.status = data.status;
                }
                if ("paymentType" in data && data.paymentType != undefined) {
                    this.paymentType = data.paymentType;
                }
                if ("metadata" in data && data.metadata != undefined) {
                    this.metadata = data.metadata;
                }
                if ("customer" in data && data.customer != undefined) {
                    this.customer = data.customer;
                }
                if ("userId" in data && data.userId != undefined) {
                    this.userId = data.userId;
                }
                if ("tenantId" in data && data.tenantId != undefined) {
                    this.tenantId = data.tenantId;
                }
                if ("orderId" in data && data.orderId != undefined) {
                    this.orderId = data.orderId;
                }
                if ("coupon" in data && data.coupon != undefined) {
                    this.coupon = data.coupon;
                }
                if ("offer" in data && data.offer != undefined) {
                    this.offer = data.offer;
                }
            }
            if (!this.metadata)
                this.metadata = new Map();
        }
        get id() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set id(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get items() {
            return pb_1.Message.getRepeatedWrapperField(this, LineItem, 2) as LineItem[];
        }
        set items(value: LineItem[]) {
            pb_1.Message.setRepeatedWrapperField(this, 2, value);
        }
        get currency() {
            return pb_1.Message.getFieldWithDefault(this, 3, "") as string;
        }
        set currency(value: string) {
            pb_1.Message.setField(this, 3, value);
        }
        get totalAmount() {
            return pb_1.Message.getFieldWithDefault(this, 4, 0) as number;
        }
        set totalAmount(value: number) {
            pb_1.Message.setField(this, 4, value);
        }
        get successUrl() {
            return pb_1.Message.getFieldWithDefault(this, 5, "") as string;
        }
        set successUrl(value: string) {
            pb_1.Message.setField(this, 5, value);
        }
        get cancelUrl() {
            return pb_1.Message.getFieldWithDefault(this, 6, "") as string;
        }
        set cancelUrl(value: string) {
            pb_1.Message.setField(this, 6, value);
        }
        get status() {
            return pb_1.Message.getFieldWithDefault(this, 7, CheckoutStatus.CHECKOUT_STATUS_UNSPECIFIED) as CheckoutStatus;
        }
        set status(value: CheckoutStatus) {
            pb_1.Message.setField(this, 7, value);
        }
        get paymentType() {
            return pb_1.Message.getWrapperField(this, dependency_1.payments.v1.PaymentType, 8) as dependency_1.payments.v1.PaymentType;
        }
        set paymentType(value: dependency_1.payments.v1.PaymentType) {
            pb_1.Message.setWrapperField(this, 8, value);
        }
        get hasPaymentType() {
            return pb_1.Message.getField(this, 8) != null;
        }
        get metadata() {
            return pb_1.Message.getField(this, 9) as any as Map<string, string>;
        }
        set metadata(value: Map<string, string>) {
            pb_1.Message.setField(this, 9, value as any);
        }
        get customer() {
            return pb_1.Message.getWrapperField(this, CustomerInfo, 10) as CustomerInfo;
        }
        set customer(value: CustomerInfo) {
            pb_1.Message.setWrapperField(this, 10, value);
        }
        get hasCustomer() {
            return pb_1.Message.getField(this, 10) != null;
        }
        get userId() {
            return pb_1.Message.getFieldWithDefault(this, 11, "") as string;
        }
        set userId(value: string) {
            pb_1.Message.setField(this, 11, value);
        }
        get tenantId() {
            return pb_1.Message.getFieldWithDefault(this, 12, "") as string;
        }
        set tenantId(value: string) {
            pb_1.Message.setField(this, 12, value);
        }
        get orderId() {
            return pb_1.Message.getFieldWithDefault(this, 13, "") as string;
        }
        set orderId(value: string) {
            pb_1.Message.setField(this, 13, value);
        }
        get coupon() {
            return pb_1.Message.getFieldWithDefault(this, 14, "") as string;
        }
        set coupon(value: string) {
            pb_1.Message.setField(this, 14, value);
        }
        get offer() {
            return pb_1.Message.getWrapperField(this, AppliedOffer, 15) as AppliedOffer;
        }
        set offer(value: AppliedOffer) {
            pb_1.Message.setWrapperField(this, 15, value);
        }
        get hasOffer() {
            return pb_1.Message.getField(this, 15) != null;
        }
        static fromObject(data: {
            id?: string;
            items?: ReturnType<typeof LineItem.prototype.toObject>[];
            currency?: string;
            totalAmount?: number;
            successUrl?: string;
            cancelUrl?: string;
            status?: CheckoutStatus;
            paymentType?: ReturnType<typeof dependency_1.payments.v1.PaymentType.prototype.toObject>;
            metadata?: {
                [key: string]: string;
            };
            customer?: ReturnType<typeof CustomerInfo.prototype.toObject>;
            userId?: string;
            tenantId?: string;
            orderId?: string;
            coupon?: string;
            offer?: ReturnType<typeof AppliedOffer.prototype.toObject>;
        }): CheckoutSession {
            const message = new CheckoutSession({});
            if (data.id != null) {
                message.id = data.id;
            }
            if (data.items != null) {
                message.items = data.items.map(item => LineItem.fromObject(item));
            }
            if (data.currency != null) {
                message.currency = data.currency;
            }
            if (data.totalAmount != null) {
                message.totalAmount = data.totalAmount;
            }
            if (data.successUrl != null) {
                message.successUrl = data.successUrl;
            }
            if (data.cancelUrl != null) {
                message.cancelUrl = data.cancelUrl;
            }
            if (data.status != null) {
                message.status = data.status;
            }
            if (data.paymentType != null) {
                message.paymentType = dependency_1.payments.v1.PaymentType.fromObject(data.paymentType);
            }
            if (typeof data.metadata == "object") {
                message.metadata = new Map(Object.entries(data.metadata));
            }
            if (data.customer != null) {
                message.customer = CustomerInfo.fromObject(data.customer);
            }
            if (data.userId != null) {
                message.userId = data.userId;
            }
            if (data.tenantId != null) {
                message.tenantId = data.tenantId;
            }
            if (data.orderId != null) {
                message.orderId = data.orderId;
            }
            if (data.coupon != null) {
                message.coupon = data.coupon;
            }
            if (data.offer != null) {
                message.offer = AppliedOffer.fromObject(data.offer);
            }
            return message;
        }
        toObject() {
            const data: {
                id?: string;
                items?: ReturnType<typeof LineItem.prototype.toObject>[];
                currency?: string;
                totalAmount?: number;
                successUrl?: string;
                cancelUrl?: string;
                status?: CheckoutStatus;
                paymentType?: ReturnType<typeof dependency_1.payments.v1.PaymentType.prototype.toObject>;
                metadata?: {
                    [key: string]: string;
                };
                customer?: ReturnType<typeof CustomerInfo.prototype.toObject>;
                userId?: string;
                tenantId?: string;
                orderId?: string;
                coupon?: string;
                offer?: ReturnType<typeof AppliedOffer.prototype.toObject>;
            } = {};
            if (this.id != null) {
                data.id = this.id;
            }
            if (this.items != null) {
                data.items = this.items.map((item: LineItem) => item.toObject());
            }
            if (this.currency != null) {
                data.currency = this.currency;
            }
            if (this.totalAmount != null) {
                data.totalAmount = this.totalAmount;
            }
            if (this.successUrl != null) {
                data.successUrl = this.successUrl;
            }
            if (this.cancelUrl != null) {
                data.cancelUrl = this.cancelUrl;
            }
            if (this.status != null) {
                data.status = this.status;
            }
            if (this.paymentType != null) {
                data.paymentType = this.paymentType.toObject();
            }
            if (this.metadata != null) {
                data.metadata = (Object.fromEntries)(this.metadata);
            }
            if (this.customer != null) {
                data.customer = this.customer.toObject();
            }
            if (this.userId != null) {
                data.userId = this.userId;
            }
            if (this.tenantId != null) {
                data.tenantId = this.tenantId;
            }
            if (this.orderId != null) {
                data.orderId = this.orderId;
            }
            if (this.coupon != null) {
                data.coupon = this.coupon;
            }
            if (this.offer != null) {
                data.offer = this.offer.toObject();
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.id.length)
                writer.writeString(1, this.id);
            if (this.items.length)
                writer.writeRepeatedMessage(2, this.items, (item: LineItem) => item.serialize(writer));
            if (this.currency.length)
                writer.writeString(3, this.currency);
            if (this.totalAmount != 0)
                writer.writeInt32(4, this.totalAmount);
            if (this.successUrl.length)
                writer.writeString(5, this.successUrl);
            if (this.cancelUrl.length)
                writer.writeString(6, this.cancelUrl);
            if (this.status != CheckoutStatus.CHECKOUT_STATUS_UNSPECIFIED)
                writer.writeEnum(7, this.status);
            if (this.hasPaymentType)
                writer.writeMessage(8, this.paymentType, () => this.paymentType.serialize(writer));
            for (const [key, value] of this.metadata) {
                writer.writeMessage(9, this.metadata, () => {
                    writer.writeString(1, key);
                    writer.writeString(2, value);
                });
            }
            if (this.hasCustomer)
                writer.writeMessage(10, this.customer, () => this.customer.serialize(writer));
            if (this.userId.length)
                writer.writeString(11, this.userId);
            if (this.tenantId.length)
                writer.writeString(12, this.tenantId);
            if (this.orderId.length)
                writer.writeString(13, this.orderId);
            if (this.coupon.length)
                writer.writeString(14, this.coupon);
            if (this.hasOffer)
                writer.writeMessage(15, this.offer, () => this.offer.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): CheckoutSession {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new CheckoutSession();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.id = reader.readString();
                        break;
                    case 2:
                        reader.readMessage(message.items, () => pb_1.Message.addToRepeatedWrapperField(message, 2, LineItem.deserialize(reader), LineItem));
                        break;
                    case 3:
                        message.currency = reader.readString();
                        break;
                    case 4:
                        message.totalAmount = reader.readInt32();
                        break;
                    case 5:
                        message.successUrl = reader.readString();
                        break;
                    case 6:
                        message.cancelUrl = reader.readString();
                        break;
                    case 7:
                        message.status = reader.readEnum();
                        break;
                    case 8:
                        reader.readMessage(message.paymentType, () => message.paymentType = dependency_1.payments.v1.PaymentType.deserialize(reader));
                        break;
                    case 9:
                        reader.readMessage(message, () => pb_1.Map.deserializeBinary(message.metadata as any, reader, reader.readString, reader.readString));
                        break;
                    case 10:
                        reader.readMessage(message.customer, () => message.customer = CustomerInfo.deserialize(reader));
                        break;
                    case 11:
                        message.userId = reader.readString();
                        break;
                    case 12:
                        message.tenantId = reader.readString();
                        break;
                    case 13:
                        message.orderId = reader.readString();
                        break;
                    case 14:
                        message.coupon = reader.readString();
                        break;
                    case 15:
                        reader.readMessage(message.offer, () => message.offer = AppliedOffer.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): CheckoutSession {
            return CheckoutSession.deserialize(bytes);
        }
    }
    export class AppliedOffer extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            campaignId?: string;
            campaignName?: string;
            campaignType?: string;
            discountPercent?: number;
            baseAmountCents?: number;
            discountAmountCents?: number;
            retention?: boolean;
            effectiveDiscountPercent?: number;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("campaignId" in data && data.campaignId != undefined) {
                    this.campaignId = data.campaignId;
                }
                if ("campaignName" in data && data.campaignName != undefined) {
                    this.campaignName = data.campaignName;
                }
                if ("campaignType" in data && data.campaignType != undefined) {
                    this.campaignType = data.campaignType;
                }
                if ("discountPercent" in data && data.discountPercent != undefined) {
                    this.discountPercent = data.discountPercent;
                }
                if ("baseAmountCents" in data && data.baseAmountCents != undefined) {
                    this.baseAmountCents = data.baseAmountCents;
                }
                if ("discountAmountCents" in data && data.discountAmountCents != undefined) {
                    this.discountAmountCents = data.discountAmountCents;
                }
                if ("retention" in data && data.retention != undefined) {
                    this.retention = data.retention;
                }
                if ("effectiveDiscountPercent" in data && data.effectiveDiscountPercent != undefined) {
                    this.effectiveDiscountPercent = data.effectiveDiscountPercent;
                }
            }
        }
        get campaignId() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set campaignId(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get campaignName() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set campaignName(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get campaignType() {
            return pb_1.Message.getFieldWithDefault(this, 3, "") as string;
        }
        set campaignType(value: string) {
            pb_1.Message.setField(this, 3, value);
        }
        get discountPercent() {
            return pb_1.Message.getFieldWithDefault(this, 4, 0) as number;
        }
        set discountPercent(value: number) {
            pb_1.Message.setField(this, 4, value);
        }
        get baseAmountCents() {
            return pb_1.Message.getFieldWithDefault(this, 5, 0) as number;
        }
        set baseAmountCents(value: number) {
            pb_1.Message.setField(this, 5, value);
        }
        get discountAmountCents() {
            return pb_1.Message.getFieldWithDefault(this, 6, 0) as number;
        }
        set discountAmountCents(value: number) {
            pb_1.Message.setField(this, 6, value);
        }
        get retention() {
            return pb_1.Message.getFieldWithDefault(this, 7, false) as boolean;
        }
        set retention(value: boolean) {
            pb_1.Message.setField(this, 7, value);
        }
        get effectiveDiscountPercent() {
            return pb_1.Message.getFieldWithDefault(this, 8, 0) as number;
        }
        set effectiveDiscountPercent(value: number) {
            pb_1.Message.setField(this, 8, value);
        }
        static fromObject(data: {
            campaignId?: string;
            campaignName?: string;
            campaignType?: string;
            discountPercent?: number;
            baseAmountCents?: number;
            discountAmountCents?: number;
            retention?: boolean;
            effectiveDiscountPercent?: number;
        }): AppliedOffer {
            const message = new AppliedOffer({});
            if (data.campaignId != null) {
                message.campaignId = data.campaignId;
            }
            if (data.campaignName != null) {
                message.campaignName = data.campaignName;
            }
            if (data.campaignType != null) {
                message.campaignType = data.campaignType;
            }
            if (data.discountPercent != null) {
                message.discountPercent = data.discountPercent;
            }
            if (data.baseAmountCents != null) {
                message.baseAmountCents = data.baseAmountCents;
            }
            if (data.discountAmountCents != null) {
                message.discountAmountCents = data.discountAmountCents;
            }
            if (data.retention != null) {
                message.retention = data.retention;
            }
            if (data.effectiveDiscountPercent != null) {
                message.effectiveDiscountPercent = data.effectiveDiscountPercent;
            }
            return message;
        }
        toObject() {
            const data: {
                campaignId?: string;
                campaignName?: string;
                campaignType?: string;
                discountPercent?: number;
                baseAmountCents?: number;
                discountAmountCents?: number;
                retention?: boolean;
                effectiveDiscountPercent?: number;
            } = {};
            if (this.campaignId != null) {
                data.campaignId = this.campaignId;
            }
            if (this.campaignName != null) {
                data.campaignName = this.campaignName;
            }
            if (this.campaignType != null) {
                data.campaignType = this.campaignType;
            }
            if (this.discountPercent != null) {
                data.discountPercent = this.discountPercent;
            }
            if (this.baseAmountCents != null) {
                data.baseAmountCents = this.baseAmountCents;
            }
            if (this.discountAmountCents != null) {
                data.discountAmountCents = this.discountAmountCents;
            }
            if (this.retention != null) {
                data.retention = this.retention;
            }
            if (this.effectiveDiscountPercent != null) {
                data.effectiveDiscountPercent = this.effectiveDiscountPercent;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.campaignId.length)
                writer.writeString(1, this.campaignId);
            if (this.campaignName.length)
                writer.writeString(2, this.campaignName);
            if (this.campaignType.length)
                writer.writeString(3, this.campaignType);
            if (this.discountPercent != 0)
                writer.writeInt32(4, this.discountPercent);
            if (this.baseAmountCents != 0)
                writer.writeInt64(5, this.baseAmountCents);
            if (this.discountAmountCents != 0)
                writer.writeInt64(6, this.discountAmountCents);
            if (this.retention != false)
                writer.writeBool(7, this.retention);
            if (this.effectiveDiscountPercent != 0)
                writer.writeDouble(8, this.effectiveDiscountPercent);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): AppliedOffer {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new AppliedOffer();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.campaignId = reader.readString();
                        break;
                    case 2:
                        message.campaignName = reader.readString();
                        break;
                    case 3:
                        message.campaignType = reader.readString();
                        break;
                    case 4:
                        message.discountPercent = reader.readInt32();
                        break;
                    case 5:
                        message.baseAmountCents = reader.readInt64();
                        break;
                    case 6:
                        message.discountAmountCents = reader.readInt64();
                        break;
                    case 7:
                        message.retention = reader.readBool();
                        break;
                    case 8:
                        message.effectiveDiscountPercent = reader.readDouble();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): AppliedOffer {
            return AppliedOffer.deserialize(bytes);
        }
    }
    export class Address extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            zipCode?: string;
            street?: string;
            number?: string;
            complement?: string;
            neighborhood?: string;
            city?: string;
            state?: string;
            country?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("zipCode" in data && data.zipCode != undefined) {
                    this.zipCode = data.zipCode;
                }
                if ("street" in data && data.street != undefined) {
                    this.street = data.street;
                }
                if ("number" in data && data.number != undefined) {
                    this.number = data.number;
                }
                if ("complement" in data && data.complement != undefined) {
                    this.complement = data.complement;
                }
                if ("neighborhood" in data && data.neighborhood != undefined) {
                    this.neighborhood = data.neighborhood;
                }
                if ("city" in data && data.city != undefined) {
                    this.city = data.city;
                }
                if ("state" in data && data.state != undefined) {
                    this.state = data.state;
                }
                if ("country" in data && data.country != undefined) {
                    this.country = data.country;
                }
            }
        }
        get zipCode() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set zipCode(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get street() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set street(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get number() {
            return pb_1.Message.getFieldWithDefault(this, 3, "") as string;
        }
        set number(value: string) {
            pb_1.Message.setField(this, 3, value);
        }
        get complement() {
            return pb_1.Message.getFieldWithDefault(this, 4, "") as string;
        }
        set complement(value: string) {
            pb_1.Message.setField(this, 4, value);
        }
        get neighborhood() {
            return pb_1.Message.getFieldWithDefault(this, 5, "") as string;
        }
        set neighborhood(value: string) {
            pb_1.Message.setField(this, 5, value);
        }
        get city() {
            return pb_1.Message.getFieldWithDefault(this, 6, "") as string;
        }
        set city(value: string) {
            pb_1.Message.setField(this, 6, value);
        }
        get state() {
            return pb_1.Message.getFieldWithDefault(this, 7, "") as string;
        }
        set state(value: string) {
            pb_1.Message.setField(this, 7, value);
        }
        get country() {
            return pb_1.Message.getFieldWithDefault(this, 8, "") as string;
        }
        set country(value: string) {
            pb_1.Message.setField(this, 8, value);
        }
        static fromObject(data: {
            zipCode?: string;
            street?: string;
            number?: string;
            complement?: string;
            neighborhood?: string;
            city?: string;
            state?: string;
            country?: string;
        }): Address {
            const message = new Address({});
            if (data.zipCode != null) {
                message.zipCode = data.zipCode;
            }
            if (data.street != null) {
                message.street = data.street;
            }
            if (data.number != null) {
                message.number = data.number;
            }
            if (data.complement != null) {
                message.complement = data.complement;
            }
            if (data.neighborhood != null) {
                message.neighborhood = data.neighborhood;
            }
            if (data.city != null) {
                message.city = data.city;
            }
            if (data.state != null) {
                message.state = data.state;
            }
            if (data.country != null) {
                message.country = data.country;
            }
            return message;
        }
        toObject() {
            const data: {
                zipCode?: string;
                street?: string;
                number?: string;
                complement?: string;
                neighborhood?: string;
                city?: string;
                state?: string;
                country?: string;
            } = {};
            if (this.zipCode != null) {
                data.zipCode = this.zipCode;
            }
            if (this.street != null) {
                data.street = this.street;
            }
            if (this.number != null) {
                data.number = this.number;
            }
            if (this.complement != null) {
                data.complement = this.complement;
            }
            if (this.neighborhood != null) {
                data.neighborhood = this.neighborhood;
            }
            if (this.city != null) {
                data.city = this.city;
            }
            if (this.state != null) {
                data.state = this.state;
            }
            if (this.country != null) {
                data.country = this.country;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.zipCode.length)
                writer.writeString(1, this.zipCode);
            if (this.street.length)
                writer.writeString(2, this.street);
            if (this.number.length)
                writer.writeString(3, this.number);
            if (this.complement.length)
                writer.writeString(4, this.complement);
            if (this.neighborhood.length)
                writer.writeString(5, this.neighborhood);
            if (this.city.length)
                writer.writeString(6, this.city);
            if (this.state.length)
                writer.writeString(7, this.state);
            if (this.country.length)
                writer.writeString(8, this.country);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): Address {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new Address();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.zipCode = reader.readString();
                        break;
                    case 2:
                        message.street = reader.readString();
                        break;
                    case 3:
                        message.number = reader.readString();
                        break;
                    case 4:
                        message.complement = reader.readString();
                        break;
                    case 5:
                        message.neighborhood = reader.readString();
                        break;
                    case 6:
                        message.city = reader.readString();
                        break;
                    case 7:
                        message.state = reader.readString();
                        break;
                    case 8:
                        message.country = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): Address {
            return Address.deserialize(bytes);
        }
    }
    export class CustomerInfo extends pb_1.Message {
        #one_of_decls: number[][] = [[6], [7], [8]];
        constructor(data?: any[] | ({
            name?: string;
            document?: string;
            email?: string;
            phone?: string;
            billingAddress?: Address;
        } & (({
            stateRegistration?: string;
        }) | ({
            companyName?: string;
        }) | ({
            birthDate?: dependency_2.google.protobuf.Timestamp;
        })))) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("name" in data && data.name != undefined) {
                    this.name = data.name;
                }
                if ("document" in data && data.document != undefined) {
                    this.document = data.document;
                }
                if ("email" in data && data.email != undefined) {
                    this.email = data.email;
                }
                if ("phone" in data && data.phone != undefined) {
                    this.phone = data.phone;
                }
                if ("billingAddress" in data && data.billingAddress != undefined) {
                    this.billingAddress = data.billingAddress;
                }
                if ("stateRegistration" in data && data.stateRegistration != undefined) {
                    this.stateRegistration = data.stateRegistration;
                }
                if ("companyName" in data && data.companyName != undefined) {
                    this.companyName = data.companyName;
                }
                if ("birthDate" in data && data.birthDate != undefined) {
                    this.birthDate = data.birthDate;
                }
            }
        }
        get name() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set name(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get document() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set document(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get email() {
            return pb_1.Message.getFieldWithDefault(this, 3, "") as string;
        }
        set email(value: string) {
            pb_1.Message.setField(this, 3, value);
        }
        get phone() {
            return pb_1.Message.getFieldWithDefault(this, 4, "") as string;
        }
        set phone(value: string) {
            pb_1.Message.setField(this, 4, value);
        }
        get billingAddress() {
            return pb_1.Message.getWrapperField(this, Address, 5) as Address;
        }
        set billingAddress(value: Address) {
            pb_1.Message.setWrapperField(this, 5, value);
        }
        get hasBillingAddress() {
            return pb_1.Message.getField(this, 5) != null;
        }
        get stateRegistration() {
            return pb_1.Message.getFieldWithDefault(this, 6, "") as string;
        }
        set stateRegistration(value: string) {
            pb_1.Message.setOneofField(this, 6, this.#one_of_decls[0], value);
        }
        get hasStateRegistration() {
            return pb_1.Message.getField(this, 6) != null;
        }
        get companyName() {
            return pb_1.Message.getFieldWithDefault(this, 7, "") as string;
        }
        set companyName(value: string) {
            pb_1.Message.setOneofField(this, 7, this.#one_of_decls[1], value);
        }
        get hasCompanyName() {
            return pb_1.Message.getField(this, 7) != null;
        }
        get birthDate() {
            return pb_1.Message.getWrapperField(this, dependency_2.google.protobuf.Timestamp, 8) as dependency_2.google.protobuf.Timestamp;
        }
        set birthDate(value: dependency_2.google.protobuf.Timestamp) {
            pb_1.Message.setOneofWrapperField(this, 8, this.#one_of_decls[2], value);
        }
        get hasBirthDate() {
            return pb_1.Message.getField(this, 8) != null;
        }
        get _state_registration() {
            const cases: {
                [index: number]: "none" | "stateRegistration";
            } = {
                0: "none",
                6: "stateRegistration"
            };
            return cases[pb_1.Message.computeOneofCase(this, [6])];
        }
        get _company_name() {
            const cases: {
                [index: number]: "none" | "companyName";
            } = {
                0: "none",
                7: "companyName"
            };
            return cases[pb_1.Message.computeOneofCase(this, [7])];
        }
        get _birth_date() {
            const cases: {
                [index: number]: "none" | "birthDate";
            } = {
                0: "none",
                8: "birthDate"
            };
            return cases[pb_1.Message.computeOneofCase(this, [8])];
        }
        static fromObject(data: {
            name?: string;
            document?: string;
            email?: string;
            phone?: string;
            billingAddress?: ReturnType<typeof Address.prototype.toObject>;
            stateRegistration?: string;
            companyName?: string;
            birthDate?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
        }): CustomerInfo {
            const message = new CustomerInfo({});
            if (data.name != null) {
                message.name = data.name;
            }
            if (data.document != null) {
                message.document = data.document;
            }
            if (data.email != null) {
                message.email = data.email;
            }
            if (data.phone != null) {
                message.phone = data.phone;
            }
            if (data.billingAddress != null) {
                message.billingAddress = Address.fromObject(data.billingAddress);
            }
            if (data.stateRegistration != null) {
                message.stateRegistration = data.stateRegistration;
            }
            if (data.companyName != null) {
                message.companyName = data.companyName;
            }
            if (data.birthDate != null) {
                message.birthDate = dependency_2.google.protobuf.Timestamp.fromObject(data.birthDate);
            }
            return message;
        }
        toObject() {
            const data: {
                name?: string;
                document?: string;
                email?: string;
                phone?: string;
                billingAddress?: ReturnType<typeof Address.prototype.toObject>;
                stateRegistration?: string;
                companyName?: string;
                birthDate?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
            } = {};
            if (this.name != null) {
                data.name = this.name;
            }
            if (this.document != null) {
                data.document = this.document;
            }
            if (this.email != null) {
                data.email = this.email;
            }
            if (this.phone != null) {
                data.phone = this.phone;
            }
            if (this.billingAddress != null) {
                data.billingAddress = this.billingAddress.toObject();
            }
            if (this.stateRegistration != null) {
                data.stateRegistration = this.stateRegistration;
            }
            if (this.companyName != null) {
                data.companyName = this.companyName;
            }
            if (this.birthDate != null) {
                data.birthDate = this.birthDate.toObject();
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.name.length)
                writer.writeString(1, this.name);
            if (this.document.length)
                writer.writeString(2, this.document);
            if (this.email.length)
                writer.writeString(3, this.email);
            if (this.phone.length)
                writer.writeString(4, this.phone);
            if (this.hasBillingAddress)
                writer.writeMessage(5, this.billingAddress, () => this.billingAddress.serialize(writer));
            if (this.hasStateRegistration)
                writer.writeString(6, this.stateRegistration);
            if (this.hasCompanyName)
                writer.writeString(7, this.companyName);
            if (this.hasBirthDate)
                writer.writeMessage(8, this.birthDate, () => this.birthDate.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): CustomerInfo {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new CustomerInfo();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.name = reader.readString();
                        break;
                    case 2:
                        message.document = reader.readString();
                        break;
                    case 3:
                        message.email = reader.readString();
                        break;
                    case 4:
                        message.phone = reader.readString();
                        break;
                    case 5:
                        reader.readMessage(message.billingAddress, () => message.billingAddress = Address.deserialize(reader));
                        break;
                    case 6:
                        message.stateRegistration = reader.readString();
                        break;
                    case 7:
                        message.companyName = reader.readString();
                        break;
                    case 8:
                        reader.readMessage(message.birthDate, () => message.birthDate = dependency_2.google.protobuf.Timestamp.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): CustomerInfo {
            return CustomerInfo.deserialize(bytes);
        }
    }
    export class CreditCardDetails extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            paymentMethodId?: string;
            installments?: number;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("paymentMethodId" in data && data.paymentMethodId != undefined) {
                    this.paymentMethodId = data.paymentMethodId;
                }
                if ("installments" in data && data.installments != undefined) {
                    this.installments = data.installments;
                }
            }
        }
        get paymentMethodId() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set paymentMethodId(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get installments() {
            return pb_1.Message.getFieldWithDefault(this, 2, 0) as number;
        }
        set installments(value: number) {
            pb_1.Message.setField(this, 2, value);
        }
        static fromObject(data: {
            paymentMethodId?: string;
            installments?: number;
        }): CreditCardDetails {
            const message = new CreditCardDetails({});
            if (data.paymentMethodId != null) {
                message.paymentMethodId = data.paymentMethodId;
            }
            if (data.installments != null) {
                message.installments = data.installments;
            }
            return message;
        }
        toObject() {
            const data: {
                paymentMethodId?: string;
                installments?: number;
            } = {};
            if (this.paymentMethodId != null) {
                data.paymentMethodId = this.paymentMethodId;
            }
            if (this.installments != null) {
                data.installments = this.installments;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.paymentMethodId.length)
                writer.writeString(1, this.paymentMethodId);
            if (this.installments != 0)
                writer.writeInt32(2, this.installments);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): CreditCardDetails {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new CreditCardDetails();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.paymentMethodId = reader.readString();
                        break;
                    case 2:
                        message.installments = reader.readInt32();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): CreditCardDetails {
            return CreditCardDetails.deserialize(bytes);
        }
    }
}
